import React from "react";
import contact from '../assets/contactus.png'

const ContactLanding = () => {
  return (
    <>
      <div className='my-[10rem]'>
        <div className="relative flex items-center justify-center px-10">
          <div className="flex flex-wrap  max-w-6xl   items-center justify-between ">
            <div className="w-full lg:w-8/12 md:w-8/12 sm:w-full">

              <h1 className="text-[48px] text-[#1E1E1E] font-bold" data-aos="fade-right" >Contact US</h1>
              <p className="text-[20px] small-text  font-normal text-[#1E1E1E] mt-2">
                Contact us for any queries or information.
              </p>
            </div>
            <div className="w-full lg:w-4/12  md:w-4/12 sm:w-full" data-aos="fade-left">
              <div>
                <img src={contact} alt="contact" />
              </div>
            </div>
          </div>
        </div>

      </div>

 


    </>

  );
};

export default ContactLanding;